import { FC, useEffect, useMemo, useState } from 'react'
import cn from './index.module.css'
import Preloader from '@UI/Preloader'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import { favoriteCourseSort, fetchMyCoursesOrders } from './utils/api'
import MyCoursesList from '@pages/CoursesCatalog/components/MyCoursesList/MyCoursesList'

interface IMyCoursesTab {}

const MyCoursesTab: FC<IMyCoursesTab> = ({}) => {
  const user = useSelector(selectProfile)
  const [isLoading, setIsLoading] = useState(true)
  const [courses, setCourses] = useState<ICourseOrder[]>([])

  useEffect(() => {
    async function fetch() {
      setIsLoading(true)
      const courses = await fetchMyCoursesOrders(user.id)
      setCourses(courses)
      setIsLoading(false)
    }

    fetch()
  }, [user])

  const onFavoriteChange = (order: ICourseOrder) => {
    const favorite = order?.favorite === 1 ? 0 : 1

    setCourses((prev) =>
      prev
        .map((item) =>
          item?.direction_id === order?.direction_id
            ? { ...item, favorite }
            : item,
        )
        .sort(favoriteCourseSort),
    )
  }

  return (
    <div className={cn.wrapper}>
      {isLoading ? (
        <div className={cn.courseListLoadingStub}>
          <Preloader />
        </div>
      ) : (
        <MyCoursesList courses={courses} onFavoriteChange={onFavoriteChange} />
      )}
    </div>
  )
}

export default MyCoursesTab
